import { render, staticRenderFns } from "./language-listing.vue?vue&type=template&id=a4de4258&scoped=true&"
import script from "./language-listing.vue?vue&type=script&lang=js&"
export * from "./language-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4de4258",
  null
  
)

export default component.exports